import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, switchMap } from 'rxjs/operators';
import { AccountService } from '../services/account.service';
import { SystemSettingsActions } from './system-settings.actions';
import { SystemSettings } from './system-settings.state';

/**
 * https://medium.com/angular-in-depth/ngrx-action-creators-redesigned-d396960e46da
 * https://auth0.com/blog/faster-app-development-with-ngrx-8/
 */

@Injectable({
    providedIn: 'root' // No need to provide in AppModule, and now tree shakable - but must still register effects
})
export class SystemSettingsEffects {

    constructor(private actions$: Actions,
                private accountService: AccountService) {
    }

    // NgRX 8 syntax
    getSystemSettings$ = createEffect(() =>
        this.actions$
            .pipe(
                ofType(SystemSettingsActions.getSystemSettings),
                switchMap(() =>
                    this.accountService.getSystemSettings()
                        .pipe(
                            map((settings: SystemSettings) =>
                                SystemSettingsActions.getSystemSettingsSuccess(settings)
                            )

                            /*catchError(error =>
                                of(SystemSettingsActions.GET_SYSTEM_SETTINGS_FAIL({error}))
                            )*/
                        )
                )
            )
    );
}
